﻿import comboItemTemplate from '../templates/comboItem.html';

function comboItemDirective() {
    return {
        require: ['^comboList', 'comboItem'],
        restrict: 'E',
        controller: 'ComboItemCtrl',
        controllerAs: 'comboItem',
        bindToController: true,
        scope: {
            positions: '<?',
            itemIndex: '<?',
            isSelected: '<?',
            onClickEditOptions:'&?',
            isEdit: '<?',
            onClickFn:'&?',
            elem: '<?'
        },
        templateUrl: comboItemTemplate,
    };
}

export { comboItemDirective };
